// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__3UTbG","title":"Profile_title__g-gPh","mailInput":"Profile_mailInput__3tTqz","buttonContainer":"Profile_buttonContainer__2QGEg"};